import { action } from 'typesafe-actions';
import localStorage from 'local-storage';
import history from 'app/routes/history';
import { IPagination } from 'app/types/common';
import { ConnectionTypesActionTypes as types } from './types';

/* ********************************* APP ACTIONS ********************************* */

export const createConnectionType = (data): any => action(types.CREATE_CONNECTION_TYPE_REQUESTED, data);

export const updateConnectionType = (data): any => action(types.UPDATE_CONNECTION_TYPE_REQUESTED, data);

export const deleteConnectionType = (connectionTypeId): any => action(types.UPDATE_CONNECTION_TYPE_REQUESTED, connectionTypeId);

export const getConnectionType = (connectionTypeId): any => action(types.GET_CONNECTION_TYPE_REQUESTED, connectionTypeId);

export const getAllConnectionTypes = (
  pagination: IPagination = undefined,
  compile = true,
): any => action(types.GET_ALL_CONNECTION_TYPES_REQUESTED, {
  pagination,
  compile,
});

export const selectConnectionType = (connectionTypeId): any => action(types.SELECT_CONNECTION_TYPE_REQUESTED, {
  currentConnectionTypeId: connectionTypeId,
});

/* ********************************* SAGA ACTIONS ********************************* */
export const sagaActions = {
  createConnectionTypePending: (payload): any => action(types.CREATE_CONNECTION_TYPE_PENDING, payload),
  createConnectionTypeSuccess: (response): any => {
    const currentConnectionType = response.entities.connectionTypes[response.result];
    // history.push(`/payment/${currentConnectionType.paymentCollection.id}/review`);
    return action(types.CREATE_CONNECTION_TYPE_SUCCESS, {
      connectionTypesById: response.entities.connectionTypes,
      currentConnectionTypeId: response.result,
    });
  },
  updateConnectionTypePending: (payload): any => action(types.UPDATE_CONNECTION_TYPE_PENDING, payload),
  updateConnectionTypeSuccess: (response): any => action(types.UPDATE_CONNECTION_TYPE_SUCCESS, {
    connectionTypesById: response.entities.connectionTypes,
    currentConnectionTypeId: response.result,
  }),
  updateConnectionTypeFailed: (error): any => action(types.UPDATE_CONNECTION_TYPE_FAIL, {
    backendErrors: error,
  }),
  deleteConnectionTypePending: (): any => action(types.UPDATE_CONNECTION_TYPE_PENDING, {}),
  deleteConnectionTypeSuccess: (response, userId): any => {
    localStorage.set(userId, { currentConnectionTypeId: null });
    history.push('/connectionTypes');

    return action(types.DELETE_CONNECTION_TYPE_SUCCESS, {
      currentConnectionTypeId: response,
    });
  },
  getConnectionTypePending: (): any => action(types.GET_CONNECTION_TYPE_PENDING, {}),
  getConnectionTypeSuccess: (response): any => action(types.GET_CONNECTION_TYPE_SUCCESS, {
    connectionTypesById: response.entities.connectionTypes,
    currentConnectionTypeId: response.result,
  }),
  getConnectionTypeFailed: (error): any => action(types.GET_CONNECTION_TYPE_FAIL, {
    backendErrors: error,
  }),
  deleteConnectionTypeFailed: (error): any => action(types.UPDATE_CONNECTION_TYPE_FAIL, {
    backendErrors: error,
  }),
  getAllConnectionTypesPending: (pagination): any => action(types.GET_ALL_CONNECTION_TYPES_PENDING, { pagination }),
  getAllConnectionTypesSuccess: (response, meta): any => action(types.GET_ALL_CONNECTION_TYPES_SUCCESS, {
    connectionTypesById: response.entities.connectionTypes,
    connectionTypeIds: response.result,
    meta,
  }),
  getAllConnectionTypesFailed: (error): any => action(types.GET_ALL_CONNECTION_TYPES_FAIL, {
    backendErrors: error,
  }),
  createConnectionTypeFailed: (error): any => action(types.CREATE_CONNECTION_TYPE_FAIL, {
    backendErrors: error,
  }),
};

export default null;
